export enum EPartnershipApiUrl {
  request = '/api/partnership/requests',
  profileTypes = '/api/partnership/profile-types',
}
